module.exports = __webpack_public_path__ + "img/IMG_7222.d3756b96.webp";